<template>
  <section class="job-identifiers">
    <section-divider title="Identifiers" />

    <div class="job-identifiers__grid">
      <div class="job-identifiers__field">
        <span>PBJ ID</span>
        <strong>{{ associate.pbj_id ?? '-' }}</strong>
      </div>
      <div class="job-identifiers__field">
        <span>Payroll ID</span>
        <strong>{{ associate.payroll_id ?? '-' }}</strong>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import SectionDivider from '@/components/ui/section-divider.vue'

const { mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'section-divider': SectionDivider
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    })
  }
}
</script>

<style scoped>
.job-identifiers {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.job-identifiers__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 8px;
}

.job-identifiers__field {
  min-width: 0;
}

.job-identifiers__field > span {
  display: block;
  margin-bottom: 4px;
  color: var(--text-color-secondary);
  font-size: 12px;
}

.job-identifiers__field > strong {
  display: block;
  overflow-wrap: anywhere;
}
</style>
